/* unplugin-vue-components disabled */import { render } from "./password.vue?vue&type=template&id=5cc046f4"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\2025\\yddh\\web\\xsspm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__